import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import { type QuotesComponentListQueryParams } from './useQuotesComponentList';

export const useDownloadComponentListCsv: MutationFunction<
  string,
  QuotesComponentListQueryParams
> = ({ requestOptions, queryOptions } = {}) => {
  const urlPath = `/quotes/components/export`;
  const request = useRequest(requestOptions);

  return useMutation(
    (requestData) => {
      return request(urlPath, {
        init: {
          method: 'GET',
        },
        query: requestData,
        shouldConvertQueryKeysToSnakeCase: false,
      });
    },
    {
      ...queryOptions,
      mutationKey: ['quotes', 'components', 'downloadComponentListCsv'],
    },
  );
};
